/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const updateDefaultDesignsDataSchema = z.object({
	defaultFeedAdDesignId: z.string().uuid().nullable().optional(),
	defaultStoryAdDesignId: z.string().uuid().nullable().optional(),
})

export type UpdateDefaultDesignsDataSchema = z.infer<typeof updateDefaultDesignsDataSchema>
